document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.cf-video-grid')
    .forEach(initVideoGrid);
});

function initVideoGrid(section) {
  const videos = Array.from(
    section.querySelectorAll('.cf-video-grid__video')
  );

  if (!videos.length) {
    return;
  }

  const settings = {
    autoplay: section.dataset.autoplay === 'true',
    sequential: section.dataset.sequential === 'true',
    pauseOffscreen: section.dataset.pauseOffscreen === 'true'
  };

  let currentIndex = 0;
  let isVisible = false;

  function pauseAll(exceptIndex = null) {
    videos.forEach((video, index) => {
      if (index !== exceptIndex) {
        video.pause();
      }
    });
  }

  function resetAll(exceptIndex = null) {
    videos.forEach((video, index) => {
      if (index !== exceptIndex) {
        video.currentTime = 0;
      }
    });
  }

  function resume() {
    if (!isVisible || !settings.autoplay) {
      return;
    }

    videos[currentIndex].play().catch(() => {});
  }

  function play(index) {
    if (!videos[index] || !isVisible) {
      return;
    }

    pauseAll(index);
    resetAll(index);

    currentIndex = index;

    videos[currentIndex].play().catch(() => {});
  }

  function playNext() {
    if (!settings.sequential) {
      return;
    }

    const nextIndex = (currentIndex + 1) % videos.length;

    play(nextIndex);
  }

  function bindEvents() {
    videos.forEach((video, index) => {
      if (settings.sequential) {
        video.addEventListener('ended', playNext);
      }

      video.addEventListener('play', () => {
        if (currentIndex === index) {
          return;
        }

        currentIndex = index;

        pauseAll(index);
        resetAll(index);
      });
    });
  }

  function createObserver() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry.isIntersecting;

        if (!settings.pauseOffscreen) {
          if (isVisible) {
            resume();
          }

          return;
        }

        if (isVisible) {
          resume();
        } else {
          pauseAll();
        }
      },
      {
        threshold: 0.4
      }
    );

    observer.observe(section);
  }

  bindEvents();
  createObserver();
}